// client/src/layouts/ProtectedLayout.tsx
import React, { useEffect, useRef } from 'react';
import useToken from '../hooks/useToken';
import { Navigate, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import SideBar from '../components/SideBar';
import { Content } from 'antd/es/layout/layout';
import SocialButtons from '../components/SocialButtons';

type ProtectedLayoutProps = {
    children: React.ReactNode;
};

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
    const token = useToken();
    const location = useLocation();
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.focus();
        }
    }, [location]);

    if (!token) {
        return <Navigate to="/auth" />;
    }

    return <div className='flex flex-col w-[1280px] mx-auto'>
        <Layout>
            <SocialButtons />
            <SideBar />
            <Content className="my-5 ml-1 mr-6 relative">
                <div
                    ref={containerRef}
                    className="p-4 h-[calc(100%-44px)] bg-white overflow-auto rounded-[15px] shadow-md border border-solid border-slate-200"
                >
                    {children}
                </div>
            </Content>
        </Layout>
    </div>
};

export default ProtectedLayout;